<template lang="pug">
  v-dialog(:value="value" @input="close" max-width="600")
    v-card(v-if="value")
      validation-observer(ref="obs" v-slot="{ invalid, handleSubmit }")
        v-card-title Добавить прямую трасляцию
          v-spacer
          v-btn(@click="close" icon)
            v-icon mdi-close
        v-card-text
          validation-provider(
            rules="required"
            name="Название"
            vid="name"
            v-slot="{ errors, valid }"
          )
            v-text-field(
              v-model="stream.name"
              :error-messages="errors"
              label="Название видео"
              rounded filled
            )

          validation-provider(
            rules=""
            name="Описание"
            vid="description"
            v-slot="{ errors, valid }"
          )
            v-textarea(
              v-model="stream.description"
              :error-messages="errors"
              label="Описание"
              rounded filled
            )

          validation-provider(
            rules=""
            name="Ссылка на прямую трансляцию"
            vid="stream_link"
            v-slot="{ errors, valid }"
          )
            v-text-field(
              v-model="stream.stream_link"
              :error-messages="errors"
              label="Ссылка на прямую трансляцию"
              rounded filled
            )

          // Дата и время начала
          validation-provider(
            rules="required"
            name="Дата и время начала"
            vid="date_visible_link"
            v-slot="{ errors, valid }"
          )
            v-datetime-picker(
              label="Дата и время начала"
              v-model="stream.date_visible_link"
              clear-text="Очистить"
              ok-text="Выбрать"
              :time-picker-props="{ format: '24hr' }"
              :text-field-props="{ rounded: true, filled: true, hideDetails: true }"
            )
              template(v-slot:dateIcon)
                v-icon mdi-calendar
              template(v-slot:timeIcon)
                v-icon mdi-clock-outline

          v-spacer.mb-6
          // Дата и время окончания
          validation-provider(
            rules="required"
            name="Дата и время окончания"
            vid="date_hidden_link"
            v-slot="{ errors, valid }"
          )
            v-datetime-picker(
              label="Дата и время окончания"
              v-model="stream.date_hidden_link"
              clear-text="Очистить"
              ok-text="Выбрать"
              :time-picker-props="{ format: '24hr' }"
              :text-field-props="{ rounded: true, filled: true, hideDetails: true }"
            )
              template(v-slot:dateIcon)
                v-icon mdi-calendar
              template(v-slot:timeIcon)
                v-icon mdi-clock-outline

        v-card-actions
          v-spacer
          v-btn(
            v-if="editData"
            color="success"
            :loading="loadingButton"
            @click="handleSubmit(updateStream)"
            text
          ) Изменить
          v-btn(
            v-else
            color="success"
            :loading="loadingButton"
            @click="handleSubmit(addStream)"
            text
          ) Добавить
          v-btn(color="warning" @click="close" text) Закрыть
</template>

<script>

export default {
  name: 'AddStreamDialog',
  props: {
    value: { type: Boolean, default: false },
    lessonInstance: { type: Object, default: null },
    editData: { type: Object, default: null },
  },
  data() {
    return {
      loadingButton: false,
      stream: {
        name: '',
        stream_link: '',
        description: '',
        date_visible_link: '',
        date_hidden_link: '',
      },
    };
  },
  watch: {
    value(val) {
      if (val && this.editData) {
        this.stream = { ...this.editData };
        this.stream.date_visible_link = new Date(this.stream.date_visible_link);
        this.stream.date_hidden_link = new Date(this.stream.date_hidden_link);
      }
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
      this.stream = {};
      this.$refs.obs.reset();
    },
    addStream() {
      if (this.lessonInstance) {
        this.loadingButton = true;
        this.$rHandler(
          this.$api.lessons.createStream(this.lessonInstance.id, this.stream),
          (r) => {
            this.stream = r.data.data;
            this.loadingButton = false;
            this.$emit('stream:add', { ...this.stream });
            this.close();
          },
          () => {
            this.loadingButton = false;
          },
          this.$refs.obs,
        );
      } else {
        this.$emit('stream:add', { ...this.stream });
        this.close();
      }
    },
    updateStream() {
      if (this.lessonInstance) {
        this.loadingButton = true;
        this.$rHandler(
          this.$api.lessons.updateStream(this.stream.id, this.stream),
          () => {
            this.loadingButton = false;
            this.$emit('stream:edit', { ...this.stream });
            this.close();
          },
          () => {
            this.loadingButton = false;
          },
          this.$refs.obs,
        );
      } else {
        this.$emit('stream:edit', { data: { ...this.stream }, index: this.editData.index });
        this.close();
      }
    },
  },
};
</script>

<style scoped>

</style>
